export const loadSeonFingerprintSdk = () => import('@seontechnologies/seon-javascript-sdk')

export const loadSeonStreamSdk = () => import('@seontechnologies/seon-stream-sdk-web')
